import { API_URL } from "env"
interface SliderAPIResponse {
    data: {
        items: Array<{
            id: number
            name: string
            slug: string
            position: number
            avatar: string
            link: string
            created_at: string
        }>
        total: number
        last_page: number
    }
    msg: string
    status: boolean
}
async function getHomeSliderImages(lang: string): Promise<SliderAPIResponse> {
    try {
        const response = await fetch(`${API_URL}/api/v1/fe/sliders?lang=${lang}`)
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const data = await response.json()
        return (data as SliderAPIResponse) || {
            data: { items: [], total: 0, last_page: 0 },
            msg: "No data",
            status: false,
        }
    } catch (error) {
        console.error("Error fetching slider images:", error)
        return {
            data: { items: [], total: 0, last_page: 0 },
            msg: "Error fetching data",
            status: false,
        }
    }
}

export { getHomeSliderImages }